<script>
  import {getContext} from 'svelte';
  
  export let href;

  const history = getContext('history');

  function onClick(e) {
    e.preventDefault();
    history.push(href);
  }

</script>

<a href={href} on:click={onClick}><slot></slot></a>